<template>
  <div class="bg">
    <img class="logo" :src="$_syscfg.product_logo" alt="logo">
    <!-- <img class="logo" src="@assets/img/login/login_logo.svg" alt="logo"> -->
    <div class="box">
      <img :src="loginMethod === 'account' ? icon.qr : icon.pc" alt="corner" class="corner" @click="toggleMethod()" v-if="(loginMethod == 'weixin' || loginMethod == 'account') && !noQr">
      <div class="loginBox" v-if="loginMethod === 'account'">
        <div class="tabs">
          <p v-for="(tab, tabindex) in tabs" :key="tabindex" :class="{active: activeTab === tab}" @click="toggleTab(tab)">
            {{tab}}
          </p>
        </div>
        <div class="account" v-if="activeTab === '账号登录'">
          <div class="item">
            <input type="text" placeholder="请输入手机号/账号/邮箱" v-model="account.account" id="LoginForm[username]">
          </div>
          <div class="item">
            <input type="password" placeholder="请输入密码" v-model="account.pswd" @keyup.enter="tapLogin()" id="LoginForm[password]">
          </div>
          <div class="item" v-if="verifys.account">
            <input type="text" placeholder="请输入验证码" v-model="account.verify">
            <div class="button" @click="account.fresh()">
              <img :src="account.verifyImg" alt="验证码">
            </div>
          </div>
        </div>
        <div class="message" v-if="activeTab === '短信快捷登录'">
          <div class="item">
            <input autocomplete="off" type="text" placeholder="请输入手机号" v-model="sms.phone">
          </div>
          <div class="item">
            <input autocomplete="off" type="text" placeholder="请输入短信验证码" v-model="sms.code" @keyup.enter="tapLogin()">
            <div class="button" @click="sendVerify()">
              {{countDown.text || '发送验证码'}}
            </div>
          </div>
          <div class="item" v-if="verifys.sms">
            <input autocomplete="off" type="text" placeholder="请输入验证码" v-model="sms.verify">
            <div class="button" @click="sms.fresh()">
              <img :src="sms.verifyImg" alt="验证码">
            </div>
          </div>
        </div>
        <div class="condition">
          <div class="check" @click="toggleRememberMe()">
            <div :class="{checkBox: true, active: rememberMe}">
              <img v-if="rememberMe" src="@assets/img/login/checker.svg" alt="checked">
            </div>
            <span>记住我</span>
          </div>
          <p v-if="change_password" @click="goFind()">忘记密码</p>
        </div>
        <div class="bigButton" @click="tapLogin()" id="LoginForm[submit]">
          登录
        </div>
      </div>
      <div class="weixin" v-if="loginMethod === 'weixin'">
        <div class="tab">
          <span>
            APP扫码登录
          </span>
        </div>
        <div class="wxQR">
          <img class="qr" :src="qrLogin.qr" alt="二维码">
          <div class="mask" v-show="qrLogin.scaned">
            <img src="@assets/img/login/scan.svg" alt="scan">
            <p class="success">扫描成功</p>
            <p>请在手机上确认登录</p>
          </div>
          <div class="mask" v-show="qrLogin.showTimeout">
            <p class="success">二维码已失效</p>
            <div class="fresh" @click="qrLogin.getAppQrCode()">
              请点击刷新
            </div>
          </div>
        </div>
        <p class="prompt">
          {{`请使用最新版${$_syscfg.title}客户端扫码`}}
        </p>
      </div>
      <div class="forget" v-if="loginMethod === 'reset' || loginMethod === 'find'">
        <div class="find" v-if="loginMethod === 'find'">
          <div class="tab">
            找回密码
          </div>
          <div class="item">
            <input autocomplete="off" type="text" placeholder="请输入手机或工作邮箱" v-model="find.phone" @input="countCode">
          </div>
          <div class="item">
            <input autocomplete="off" type="text" placeholder="请输入验证码" v-model="find.code" @input="countCode">
            <div :class="{button: true, disable: !find.sendCode}" @click="sendFindVerify()">
              {{countDown.text || '发送验证码'}}
            </div>
          </div>
          <div v-show="showErrCode" class="item">
            <input autocomplete="off" type="text" placeholder="请输入验证码" v-model="find.verify" @input="checkFindCode()">
            <div class="button" @click="find.fresh()">
              <img :src="find.verifyImg" alt="验证码">
            </div>
          </div>
          <div :class="{bigButton: true, buttonDisable: !reset.nextStep}" @click="checkInfo()">
            下一步
          </div>
          <div v-show="showCodeNotify" class="codeNotify">验证码已发送至<span>{{find.phone}}</span></div>
        </div>
        <div class="reset" v-if="loginMethod === 'reset'">
          <div class="tab">
            重置密码
          </div>
          <div class="item">
            <input type="password" placeholder="请输入新密码（8-16位，包含字母和数字）" v-model="reset.pwd" @input="countCode1">
          </div>
          <div class="item">
            <input type="password" placeholder="请再次输入密码" v-model="reset.pwd2" @input="countCode1">
          </div>
          <div class="tip">
            <img src="@assets/img/user/tip.svg" alt="tip">
            <span>8-16位 (含大、小写字母+数字+特殊字符)</span>
          </div>
          <div :class="{bigButton: true,buttonDisable: resetGrey}" @click="resetPwd1">
            完成重置
          </div>
        </div>
        <p class="backtoaccount">已有账号，<span @click="backtoaccount()">马上登录</span></p>
      </div>
    </div>
    <div v-show="showPlatform" class="platformMask">
      <div class="platformBox">
        <div class="title">此次密码修改将同步至：</div>
        <div class="content">
          <ul>
            <li v-for="(item,index) in relativeSystem" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="btns">
          <div @click="showPlatform = false;resetComplete()" class="btn on">确定</div>
          <div @click="showPlatform = false" class="btn">取消</div>
        </div>
      </div>
    </div>
    <p class="statement">
      SMT RDC 提供技术支持
    </p>
  </div>
</template>

<script>

import qr from '@assets/img/login/login_qr.png'
import pc from '@assets/img/login/login_pc.png'
import common from '@common/common'
import {apis} from '@common/config'
import dc from '@common/dc'

export default {
  name: 'login',
  data() {
    return {
      resetGrey: true,
      showErrCode: false,
      relativeSystem: [],
      showPlatform: false,
      errCodeNum: 0,
      showCodeNotify: false,
      icon: {
        qr: qr,
        pc: pc
      },
      tabs: [],
      activeTab: '',
      rememberMe: false,
      noQr: false,  // 隐藏扫码登录
      loginMethod:  'account',  // 'weixin', 'account', 'find', 'reset'
      account: {
        account: '',
        pswd: '',
        verifyImg: '',
        verify: '',
        codekey: '',
        fresh: () => {
          return common.myFetch(apis.Log_verify_img, {method: 'get', needLogin: false, data: {}})
          .then((data) => {
            this.account.verifyImg = data.base64
            this.account.codekey = data.codekey
          })
        }
      },
      sms: {
        phone: '',
        code: '',
        verifyImg: '',
        verify: '',
        codekey: '',
        fresh: () => {
          return common.myFetch(apis.Log_verify_img, {method: 'get', needLogin: false, data: {}})
          .then((data) => {
            this.sms.verifyImg = data.base64
            this.sms.codekey = data.codekey
          })
        }
      },
      find: {
        phone: '',
        verify: '',
        verifyImg: '',
        code: '',
        codekey: '',
        sendCode: true,
        fresh: () => {
          return common.myFetch(apis.Log_verify_img, {method: 'get', needLogin: false, data: {}})
          .then((data) => {
            this.find.verifyImg = data.base64
            this.find.codekey = data.codekey
          })
        }
      },
      reset: {
        pwd: '',
        pwd2: '',
        nextStep: false
      },
      qrLogin: {
        qr: '',
        qrKey: '',
        showTimeout: false,
        scaned: false,
        timeout: null,
        autoScan: null,
        autoLogin: null,
        getAppQrCode: () => {
          // 获取App扫描二维码
          common.myFetch(apis.Log_qrcode, {method: 'post', needLogin: false, data: {}})
          .then(r => {
            if (r) {
              this.qrLogin.showTimeout = false
              this.qrLogin.qr = r.qrcode
              this.qrLogin.qrKey = r.name
              this.qrLogin.timeout = setTimeout(() => {
                // 自动刷新二维码
                this.qrLogin.showTimeout = true
                this.qrLogin.scaned = false
                if (this.qrLogin.autoScan) {
                  clearInterval(this.qrLogin.autoScan)
                  this.qrLogin.autoScan = null
                }

                if (this.qrLogin.autoLogin) {
                  clearInterval(this.qrLogin.autoLogin)
                  this.qrLogin.autoLogin = null
                }
              }, r.time*1000)
              this.qrLogin.autoScan = setInterval(() => {
                this.qrLogin.checkScan()
              }, 1000)
            }
          })
        },
        checkScan: () => {
          // 查询二维码扫描状态
          const info = {
            key: this.qrLogin.qrKey
          }

          common.myFetch(apis.Log_qrscan, {method: 'post', hideLoading: true, needLogin: false, data: info})
          .then(r => {
            if (r) {
              if (r.code == 1) return

              this.qrLogin.scaned = true
              // clearTimeout(this.qrLogin.timeout)
              if (this.qrLogin.autoScan) {
                  clearInterval(this.qrLogin.autoScan)
                  this.qrLogin.autoScan = null
              }
              this.qrLogin.autoLogin = this.qrLogin.autoLogin || setInterval(() => {
                this.qrLogin.login()
              }, 1000)
            }
          })
        },
        login: () => {
          // 二维码登录
          const info = {
            key: this.qrLogin.qrKey
          }

          common.myFetch(apis.Log_qrlogin, {method: 'post', needLogin: false, data: info})
          .then(r => {
            if (r) {
              if (r.type == 1) {
                clearInterval(this.qrLogin.autoLogin)
                this.qrLogin.autoLogin = null
                this.qrLogin.scaned = false
                this.writeLoginInfo(r.result)
                this.goIndex()
              }
            }
          })
        }
      },
      verifys: {
        account: false,
        sms: false
      },
      countDown: {
        durantion: 60,
        count: null,
        seconds: 60,
        text: '',
        active: false
      },
      change_password: true
    }
  },
  methods: {
    backtoaccount() {
      this.loginMethod = 'account'
    },
    getLoginMethods() {
      // 获取登录页配置
      common.myFetch(apis.Log_loginMtds, {method: 'post', needLogin: false, data: {}})
      .then((r) => {
        if (r.username_login) {
          // 账号登录
          this.tabs.push('账号登录')
        }

        if (r.phone_login) {
          // 短信登录
          this.tabs.push('短信快捷登录')
        }

        if (!r.qrcode_login) {
          // 扫码登录
          this.noQr = true
        }

        this.change_password = r.change_password;

        this.activeTab = this.tabs[0]
      })
    },
    toggleTab(tab) {
      this.activeTab = tab
    },
    toggleRememberMe() {
      this.rememberMe = !this.rememberMe
    },
    toggleMethod() {
      if (this.noQr) return

      this.loginMethod = this.loginMethod === 'weixin' ? 'account' : 'weixin'

      if (this.loginMethod === 'weixin') {
        this.qrLogin.getAppQrCode()
      } else {
        this.cancelAuto()
      }
    },
    goFind() {
      this.find.fresh()
      .then(() => {
        this.loginMethod = 'find'
      })
    },
    goReset() {
      this.loginMethod = 'reset'
    },
    goAccount() {
      this.loginMethod = 'account'
    },
    goIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    checkInfo () {
      // 检验手机，验证码，短信
      if (!this.reset.nextStep) {
        return
      }

      this.checkPhone().then((res) => {
        console.log(res)
        if (res) {
          // this.errCodeNum = 0
          this.goReset()
        } else {
          // this.errCodeNum ++
          // 提示
        }
      })
    },
    resetComplete() {
      // 重置密码完成
      this.resetPwd().then((res) => {
        if (res) {
          if(!res.needReBind){
            this.$toast(res)
            this.loginMethod = 'account'
          }
        } else {
          // 提示
        }
      })
    },
    getRelativeSystem(name) {
      let info = {
        loginname: name
      }
      common.myFetch(apis.getRelativeSystems, {method: 'get', needLogin: false, data: info}).then(res => {
        if(res){
          this.relativeSystem = res
          console.log(res)
        }
      })
    },
    async tapLogin() {
      // 登录按钮事件，根据渠道调用相应事件
      if (this.activeTab === '账号登录') {

        // let checkPassWord = await common.checkPassWord(this.account.pswd);

        // if(checkPassWord){
        this.accountLogin()
        // }else{
        //   this.$toast('密码为弱密码，请联系管理员')
        // }
        
      } else {
        this.phoneLogin()
      }
    },
    writeLoginInfo(data) {
      // 记录登录信息
      const uidInfo = {
        name: common.UK(),
        value: data.uid,
        expires: 1,
        path: '/'
      }

      const unidInfo = {
        name: common.UNK(),
        value: data.unid,
        expires: 1,
        path: '/'
      }

      common.setCookie(uidInfo)
      common.setCookie(unidInfo)
    },
    async accountLogin() {
      // 清除既存信息
      common.clearUser()
      // 账号登录
      const account = this.account.account
      const pwd = this.account.pswd
      const pswd = await common.encrypt(pwd)
      const valicode = this.account.verify
      const codekey = this.account.codekey
      const info = {
        username: account,
        password: pswd
      }

      if(!pwd){
        this.$toast('密码不能为空')
        return false
      }

      if (codekey) {
        info['valicode'] = valicode
        info['codekey'] = codekey
      }

      common.myFetch(apis.Log_account_login, {method: 'post', needLogin: false, data: info})
      .then(async (data) => {
        if (!data) return
        if (data.needVerify) {
          this.account.fresh().then(() => {
            this.verifys.account = true
          })
        } else {
          // let checkPassWord = await common.checkPassWord(this.account.pswd);
          // if(checkPassWord){
            dc.delUsrInfo()
            this.$toast('登录成功')
            this.writeLoginInfo(data)

            if (this.rememberMe) {
              dc.setUserName(account)
              dc.setUserPwd(pwd)
            } else {
              dc.delUserName()
              dc.delUserPwd()
            }

            this.goIndex()
          // }else{
          //   this.$toast('密码为弱密码，请联系管理员')
          // }
        }
      })
    },
    phoneLogin() {
      // 短信快捷登录
      const info = {
        phone: this.sms.phone,
        code: this.sms.code
      }
      if (this.sms.codekey) {
        info['codekey'] = this.sms.codekey
      }

      common.myFetch(apis.Log_phone_login, {method: 'post', needLogin: false, data: info})
      .then((data) => {
        if (!data) return

        if (data.needVerify) {
          this.sms.fresh().then(() => {
            this.verifys.sms = true
          })
        } else {
          dc.delUsrInfo()
          this.$toast('登录成功')
          this.writeLoginInfo(data)

          if (this.rememberMe) {
             dc.setUserTel(info.phone)
          } else {
            dc.delUserTel()
          }

          this.goIndex()
        }
      })
    },
    sendVerify() {
      // console.log(this.countDown.active)
      if (this.countDown.active) return
      this.countDown.active = true
      // 短信快捷登录发送验证码
      const info = {
        phone: this.sms.phone,
        is_sms: 1
      }

      common.myFetch(apis.Log_send_verify, {method: 'post', needLogin: false, data: info})
      .then((data) => {
        if (data) {
          if(data.needReBind){
            this.countDown.active = false
          }else{
            this.$toast(data)
            if(this.countDown.count){
              clearInterval(this.countDown.count)
            }
            this.startCountDown()
          }
        }else{
          this.countDown.active = false
        }
      })
    },
    startCountDown() {
      this.countDown.count = setInterval(() => {
        this.countDown.text = `${this.countDown.seconds} s`
        this.countDown.seconds -= 1
        if (this.countDown.seconds < 0) {
          clearInterval(this.countDown.count)
          this.countDown.text = ''
          this.countDown.active = false
          this.countDown.seconds = this.countDown.durantion
          this.checkFindCode()
        }
      }, 1000)
    },
    sendFindVerify() {
      if (!this.find.sendCode) return
      this.find.sendCode = false;
      // 找回密码发送验证码
      const info = {
        phone: this.find.phone,
        valicode: this.find.verify,
        codekey: this.find.codekey
      }

      common.myFetch(apis.Log_send_verify, {method: 'post', needLogin: false, data: info})
      .then((data) => {
        if (data) {
          if(data.needReBind){
            this.checkFindCode()
          }else{
            // this.$toast(data)
            this.showCodeNotify = true;
            if(this.countDown.count){
              clearInterval(this.countDown.count)
            }
            this.startCountDown()
            setTimeout(() => {
              this.showCodeNotify = false;
            },3000)
          }
        }else{
          this.checkFindCode()
        }
      })
    },
    checkPhone() {
      // 找回密码下一步
      const info = {
        phone: this.find.phone,
        valicode: this.find.verify,
        code: this.find.code,
        codekey: this.find.codekey
      }

      return common.myFetch(apis.Log_check_phone, {method: 'post', needLogin: false, data: info})
      .then((data) => {
        if (data) {
          if(data.needReBind){
            return false
          }else if(data.needVerify){
            this.find.fresh()
            this.showErrCode = true
          }else{
            this.$toast(data)
            this.goReset()
            this.getRelativeSystem(this.find.phone)
          }
        }
      })
    },
    countCode() {
      if (this.find.code.length >= 4 && this.find.phone.length > 0) {
        this.reset.nextStep = true
      } else {
        this.reset.nextStep = false
      }
    },
    countCode1() {
      if (this.reset.pwd.length > 0 && this.reset.pwd2.length > 0) {
        this.resetGrey = false
      } else {
        this.resetGrey = true
      }
    },
    checkFindCode() {
      // if (this.find.verify.length >= 4) {
      //   this.find.sendCode = true
      // } else {
      //   this.find.sendCode = false
      // }
      this.find.sendCode = true
    },
    async resetPwd1() {
      if(this.resetGrey) return
      if(this.reset.pwd === this.reset.pwd2){
        const pwd = await common.encrypt(this.reset.pwd)
        const pwd2 = await common.encrypt(this.reset.pwd2)
        const info = {
          phone: this.find.phone,
          password: pwd,
          repassword: pwd2,
          is_validate: 1
        }

        return common.myFetch(apis.Log_reset_pwd, {method: 'post', needLogin: false, data: info})
        .then((data) => {
          if(data){
            if(!data.needReBind && !data.needVerify){
              this.showPlatform = true;
            }
          }
          // console.log(data)
        })
      }else{
        this.$toast('密码不一致')
      }
    },
    async resetPwd() {
      const checkPassWord = await common.checkPassWord(this.reset.pwd);
      if(checkPassWord){
        if(this.reset.pwd === this.reset.pwd2){
          const pwd = await common.encrypt(this.reset.pwd)
          const pwd2 = await common.encrypt(this.reset.pwd2)
          const info = {
            phone: this.find.phone,
            password: pwd,
            repassword: pwd2
          }

          return common.myFetch(apis.Log_reset_pwd, {method: 'post', needLogin: false, data: info})
          .then((data) => {
            return data
          })
        }else{
          this.$toast('密码不一致')
        }
      }else{
        this.$toast('密码不符合规范')
      }
    },
    init() {
      const name = dc.getUserName()
      const pwd = dc.getUserPwd()
      const tel = dc.getUserTel()

      if (name) {
        this.account.account = name
      }

      if (pwd) {
        this.account.pswd = pwd
      }

      if (tel) {
        this.sms.phone = tel
      }

      if (name && pwd) {
        this.rememberMe = true
      }
    },
    cancelAuto() {
      if (this.qrLogin.timeout) {
        clearTimeout(this.qrLogin.timeout)
        this.qrLogin.timeout = null
      }

      if (this.qrLogin.autoScan) {
        clearInterval(this.qrLogin.autoScan)
        this.qrLogin.autoScan = null
      }

      if (this.qrLogin.autoLogin) {
        clearInterval(this.qrLogin.autoLogin)
        this.qrLogin.autoLogin = null
      }

      this.qrLogin.showTimeout = false
      this.qrLogin.scaned = false
    }
  },
  mounted() {
    this.$AudioDownloadMessage(true)
    this.$RadioDownloadMessage(true)
    this.$DownloadMessage(true)
    this.$chatGpt('unload')
    this.$FileSend(true)
    this.$AiMessage(true)
    this.init()
    this.getLoginMethods()
    // this.countCode();
  },
  created() {
    // let downloadMessage = document.querySelectorAll('.downloadMessage')[0];
    // if(downloadMessage){
    //   document.body.removeChild(downloadMessage)
    // }
    // let fileSendMessage = document.querySelectorAll('.fileSendMessage')[0];
    // if(fileSendMessage){
    //   document.body.removeChild(fileSendMessage)
    // }
    // let chatGptMessage = document.querySelectorAll('.chatGptMessage')[0];
    // if(chatGptMessage){
    //   document.body.removeChild(chatGptMessage)
    // }
    if(this.$route.query.type == 'forget'){
      this.goFind()
    }
    common.clearUser()
  },
  destroyed() {
    this.cancelAuto()
  }
}
</script>

<style lang="less" src="@assets/css/login.less" scoped></style>
